import {Icon} from '@/domains/shared/components/Icon';
import clsx   from 'clsx';

const styles = {
	note:    {
		container: 'bg-teal-50 border-2 border-teal-600',
		title:     'text-teal-900',
		body:      'text-teal-800 [--tw-prose-background:theme(colors.teal.50)] prose-a:text-teal-900 prose-code:text-teal-900',
	},
	warning: {
		container: 'bg-amber-50 border-2 border-amber-600',
		title:     'text-amber-90',
		body:      'text-amber-800 [--tw-prose-underline:theme(colors.amber.400)] [--tw-prose-background:theme(colors.amber.50)] prose-a:text-amber-900 prose-code:text-amber-900',
	},
};

const icons = {
	note:    (props) => <Icon icon="lightbulb" {...props} />,
	warning: (props) => <Icon icon="warning"
	                          color="amber" {...props} />,
};

export function Callout({
	                        type = 'note',
	                        title,
	                        children,
                        }) {
	let IconComponent = icons[type];

	return (<div className={clsx('my-8 flex rounded-2xl p-6', styles[type].container)}>
			<IconComponent className="h-8 w-8 flex-none" />
			<div className="ml-4 flex-auto">
				<p className={clsx('m-0 font-display text-xl', styles[type].title)}>
					{title}
				</p>

				<div className={clsx('prose max-w-none mt-2.5 italic', styles[type].body)}>
					{children}
				</div>
			</div>
		</div>);
}
